import React from 'react'
import styled from 'styled-components'
import HeaderMenu from './HeaderMenu.loadable'
import useWmoEnabled from '../../hooks/useWmoEnabled'

const HeaderMenuStyled = styled(HeaderMenu)`
  ${props => props.theme.mediaQuery.down('large')} {
    display: none;
  }
`

const HeaderMenuLazyLoader = props => {
  const isWmoEnabled = useWmoEnabled()

  if (isWmoEnabled) {
    return null
  }

  return (
    <HeaderMenuStyled {...props} />
  )
}

export default HeaderMenuLazyLoader
